export function VideoPlayer({ youtubeId, title }: { youtubeId: string; title: string }) {
  if (youtubeId.startsWith("REPLACE_")) {
    return (
      <div className="video-shell video-placeholder">
        <div>
          <span>VIDEO LESSON</span>
          <strong>Add your YouTube video ID</strong>
          <p>Open the lesson content file and replace the placeholder video ID.</p>
        </div>
      </div>
    );
  }
  return (
    <div className="video-shell">
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?rel=0&modestbranding=1`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
}
